<template>
    <b-nav-item-dropdown
        class="justify-content-end"
        toggle-class="pl-1"
        right>
        <template #button-content>
            <font-awesome-icon
                :icon="['fas', 'user-circle']"
                size="lg"
            >
            </font-awesome-icon>
        </template>
      <b-dropdown-item
          disabled
      >
        {{ userFullName }}
      </b-dropdown-item>
        <b-dropdown-item
                :to="{ name: 'apps' }"
                v-if="$can(
            $perm.APPLICATIONS_CREATE_APP,
            $perm.PERMISSION_TYPE_APPS,
          )"
        >
            My Apps
        </b-dropdown-item>
        <b-dropdown-item
            :to="{ name: 'eula' }"
        >
            End User Licence Agreement
        </b-dropdown-item>
        <b-dropdown-item
            @click="logout"
        >
            <vue-element-loading :active="authLoading" :is-full-screen="false"/>
            <span v-if="!authLoading">Logout</span>
        </b-dropdown-item>
    </b-nav-item-dropdown>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'UserMenu',
  computed: {
    ...mapGetters(['userFullName']),
    authLoading() {
      return this.$auth.loading;
    },
  },
  methods: {
    logout() {
      if (this.$auth.loading) {
        this.$notify({
          title: 'Please wait and try again',
          type: 'warning',
        });
      }

      // clear dashboard FRA selection store before logging out
      this.$store.dispatch('setDueDateBy', null);

      //logout
      this.$store.dispatch('logout');
    },
  },
};
</script>
